































































































































import Vue from 'vue';
import { Team, User } from '@/models';

export default Vue.extend({
  props: {
    index: {
      type: Number,
    },
    toIndex: {
      type: String,
    },
    pathItem: {
      type: Object,
    },
  },
  mounted() {
    this.pathItem.index = this.index;
  },
  methods: {
    getTeamName(teamId: string): string {
      let team;
      if (this.$store.state.team && this.$store.state.team.teams && teamId) {
        team = this.$store.state.team.teams.find((t: Team) => t.objectId === teamId);

        return team && team.name || 'Time Desconhecido';
      }

      return 'Time Desconhecido';
    },
    getUserName(userId: string): string {
      let user;
      if (this.$store.state.user && this.$store.state.user.users && userId) {
        user = this.$store.state.user.users.find((u: User) => u.objectId === userId);
        return user && user.name || 'Usuário Desconhecido';
      }

      return 'Usuário Desconhecido';
    },
    getApiOperation(url: string): string {
      let operation;
      if (url) {
        operation = url.replace(/^.*\/(.*)$/, '$1');
        return operation;
      }

      return 'Operação Desconhecida';
    },
    editPathItem() {
      if (this.pathItem) {
        this.$emit('edit', this.pathItem);
      }
    },
    deletePathItem() {
      if (this.pathItem) {
        this.$emit('delete', this.pathItem);
      }
    },
    getIcon() {
      switch (this.pathItem.handlerConfig.channel) {
        case 'WAB':
          return 'mdiWhatsapp';
          break;

        case 'FBMESSENGER':
          return 'mdiFacebookMessenger';
          break;

        case 'WEBCHAT':
          return 'mdiChat';
          break;

        default:
          return 'mdiChat';
          break;
      }
    },
  },
  watch: {
    pathItem(val) {
      this.pathItem.index = this.index;
    },
  },
});
